var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThickArrowUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 10,
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.374196 9.6176C0.613866 9.86245 0.938885 10 1.27778 10C1.61667 10 1.94169 9.86245 2.18136 9.6176L8.50772 3.15257L14.8341 9.6176C15.0751 9.85551 15.398 9.98716 15.7331 9.98418C16.0682 9.9812 16.3887 9.84385 16.6257 9.60169C16.8626 9.35954 16.997 9.03196 17 8.68951C17.0029 8.34706 16.874 8.01715 16.6412 7.77082L9.4113 0.382399C9.17163 0.137549 8.84661 0 8.50772 0C8.16882 0 7.8438 0.137549 7.60413 0.382399L0.374196 7.77082C0.134599 8.01575 0 8.34789 0 8.69421C0 9.04053 0.134599 9.37268 0.374196 9.6176Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThickArrowUp);
export default __webpack_public_path__ + "static/media/thick_arrow_up.d1f0666c3ca67806da05119a0098cd56.svg";
export { ForwardRef as ReactComponent };